export default "__VITE_ASSET__BQAtZ0nv__"